<div [ngClass]="styles.cell">
	<vb-profile-picture [profileUrl]="item[insight.insightOptions.fieldDefs.profileImageUri]" [placeholderIconClass]="insight.getIconClass(item)" [altTxt]="item[insight.insightOptions.fieldDefs.display]"></vb-profile-picture>
</div>

<div [ngClass]="styles.descriptionCell">
	<span>{{ item[insight.insightOptions.fieldDefs.display] }}</span>
	<span *ngIf="item[insight.insightOptions.fieldDefs.subDisplay]" [ngClass]="styles.subDisplay">
		{{ item[insight.insightOptions.fieldDefs.subDisplay] }}
	</span>
</div>

<div>
	<button type="button" [ngClass]="styles.btnBadge" class="btn theme-accent" [(ngModel)]="item.categoryManager" btnCheckbox [btnCheckboxFalse]="false" [btnCheckboxTrue]="true">
		<span [ngClass]="item.categoryManager ? 'ok_2' : 'minus'" class="glyphicons">
		</span>
		{{ (item.categoryManager ? 'Media_CategoryManager' : 'Media_CategoryContributor') | translate }}
	</button>
</div>


<div>
	<button type="button" [attr.aria-label]="'Remove' | translate " class="btn btn-link float-right remove-assigned-item" (click)="insight.removeItem(item)" [attr.aria-label]="'RemoveItemType' | translate : {
			'0': item[insight.insightOptions.fieldDefs.display],
			'1': (insight.insightOptions.dataTypeLabels[item.type] | translate)
		}">
		<span class="glyphicons remove_2"></span>
	</button>
</div>
